export default "__VITE_ASSET__CI2vXzYl__"